import * as React from 'react';
import { SVGProps } from 'react';

const IconBookmarkFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.092C2 1.488 2.54 1 3.201 1h5.598C9.461 1 10 1.488 10 2.092V11L6 9l-4 2V2.092z"
    />
  </svg>
);
export default IconBookmarkFilledSizeXs;
